/*
  People's Peps cart checks. Pairs with snippets/pp-ruo-confirm.liquid.
  - Locks every Check out button tied to the cart form until every required
    box in that form's checks is ticked (research use, and Terms and ACH
    authorization when it is switched on).
  - Saves each answer as its own cart attribute (it lands on the order under
    Additional details) and keeps the cart page and cart drawer copies of the
    same box in step.
  - Opens "Why we ask" in a dialog.
  Delegated listeners plus a MutationObserver, so it keeps working after the cart
  drawer and cart page re-render their HTML on every quantity change.
*/
(function () {
  'use strict';
  if (window.__ppRuo) return;
  window.__ppRuo = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function checkoutButtons(formId) {
    var form = formId ? document.getElementById(formId) : null;
    var out = [];
    document.querySelectorAll('[name="checkout"]').forEach(function (b) {
      if (b.getAttribute('form') === formId || (form && form.contains(b))) out.push(b);
    });
    return out;
  }

  function boxes(block) {
    return Array.prototype.slice.call(block.querySelectorAll('.pp-ruo__box'));
  }

  function sync(block) {
    var list = boxes(block);
    if (!list.length) return;
    var ok = list.every(function (b) { return b.checked; });
    checkoutButtons(block.getAttribute('data-form')).forEach(function (b) {
      if (!ok) {
        if (!b.disabled) { b.disabled = true; b.setAttribute('data-pp-ruo-locked', ''); }
      } else if (b.hasAttribute('data-pp-ruo-locked')) {
        b.disabled = false;
        b.removeAttribute('data-pp-ruo-locked');
      }
    });
    var hint = block.querySelector('.pp-ruo__hint');
    if (hint) hint.hidden = ok;
    block.classList.toggle('is-ok', ok);
  }

  /* The answers given on this page, by kind. The drawer and the cart page
     re-render from the server on every quantity change, and a re-render can
     overtake the cart/update.js call that saves a tick, so a fresh copy of a
     box is set from here rather than from a cart that has not caught up. */
  var given = {};
  function restore() {
    document.querySelectorAll('[data-pp-ruo] .pp-ruo__box').forEach(function (b) {
      var k = b.getAttribute('data-kind') || 'ruo';
      if (!Object.prototype.hasOwnProperty.call(given, k)) return;
      var v = given[k];
      if (b.checked !== !!v) b.checked = !!v;
      if (v && b.value !== v) b.value = v;
    });
  }

  function syncAll() { restore(); document.querySelectorAll('[data-pp-ruo]').forEach(sync); }

  function save(key, val) {
    if (!key) return;
    var attrs = {};
    attrs[key] = val;
    fetch(ROOT + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).catch(function () { /* the form field still carries the answer at checkout */ });
  }

  document.addEventListener('change', function (e) {
    var box = e.target && e.target.closest ? e.target.closest('.pp-ruo__box') : null;
    if (!box) return;
    var ok = box.checked;
    var kind = box.getAttribute('data-kind') || 'ruo';
    /* The ticked value carries the time it was ticked, so the order shows when. */
    var val = ok ? (box.getAttribute('data-value') || '') + ' | ' + new Date().toISOString() : '';
    given[kind] = val;
    document.querySelectorAll('[data-pp-ruo] .pp-ruo__box').forEach(function (b) {
      if ((b.getAttribute('data-kind') || 'ruo') !== kind) return;
      b.checked = ok;
      b.value = ok ? val : (b.getAttribute('data-value') || b.value);
    });
    syncAll();
    save(box.getAttribute('data-key'), val);
  });

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var open = t.closest('[data-pp-ruo-open]');
    if (open) {
      var dlg = document.getElementById(open.getAttribute('data-pp-ruo-open'));
      if (dlg) {
        if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
        var first = dlg.querySelector('[data-pp-ruo-close]');
        if (first) first.focus();
      }
      e.preventDefault();
      return;
    }
    var close = t.closest('[data-pp-ruo-close]');
    var d = close ? close.closest('dialog') : (t.classList && t.classList.contains('pp-ruo__dlg') ? t : null);
    if (d) {
      if (typeof d.close === 'function') d.close(); else d.removeAttribute('open');
      e.preventDefault();
    }
  });

  /* A checkout submit never goes through unconfirmed, whatever enabled the button. */
  document.addEventListener('submit', function (e) {
    var btn = e.submitter;
    if (!btn || btn.name !== 'checkout') return;
    var form = e.target;
    var block = form && form.id ? document.querySelector('[data-pp-ruo][data-form="' + form.id + '"]') : null;
    if (!block) return;
    var miss = boxes(block).filter(function (b) { return !b.checked; })[0];
    if (miss) {
      e.preventDefault();
      e.stopImmediatePropagation();
      sync(block);
      miss.focus();
    }
  }, true);

  var queued = false;
  function queue() {
    if (queued) return;
    queued = true;
    (window.requestAnimationFrame || setTimeout)(function () { queued = false; syncAll(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncAll); else syncAll();
  new MutationObserver(queue).observe(document.documentElement, { childList: true, subtree: true });
})();
